









































import { Vue, Prop, Component } from "vue-property-decorator";
@Component
export default class extends Vue {
  @Prop() originValue!: number;
  dialogVisible: boolean = false;
  openDialog() {
    this.dialogVisible = true;
  }
  handleClose() {
    this.dialogVisible = false;
  }
  handleSubmit(v: number) {
    this.$emit("change", v);
    this.handleClose();
  }
}
